import React, { useState, useRef } from "react";
import { FaChevronRight } from "react-icons/fa";
import "./styles/Accordion.css";

function Accordion({ title, content }) {
  const [active, setActive] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setActive((prev) => !prev);
  };

  const maxHeight = active
    ? `${contentRef.current ? contentRef.current.scrollHeight : 0}px`
    : "0px";

  return (
    <div className="accordion__section">
      <button
        type="button"
        className={`accordion${active ? " active" : ""}`}
        onClick={toggleAccordion}
        aria-expanded={active}
      >
        <p className="accordion__title">{title}</p>
        <FaChevronRight
          className={`accordion__icon${active ? " rotate" : ""}`}
        />
      </button>
      <div
        ref={contentRef}
        style={{ maxHeight }}
        className="accordion__content"
      >
        <div
          className="accordion__text"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
}

export default Accordion;
